import { Link } from "react-router-dom";
import { Star, ChevronRight } from "lucide-react";

const diffColor = {
  "Başlangıç": "bg-sage/10 text-sage border-sage/20",
  "Orta": "bg-gold/10 text-[#9a7d10] border-gold/30",
  "İleri": "bg-terra/10 text-terra border-terra/20",
};

export function BookRow({ book }) {
  return (
    <Link to={`/kitap/${book.id}`} data-testid={`book-row-${book.id}`}
      className="group flex items-center gap-3 border border-line rounded-lg p-2.5 bg-surface hover:shadow-sm transition-shadow fade-up">
      <div className="h-16 w-12 shrink-0 rounded bg-ink border border-line flex items-center justify-center p-1 overflow-hidden">
        <span className="font-serif text-page text-[9px] text-center uppercase leading-tight line-clamp-4">{book.baslik}</span>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h3 className="font-serif text-base text-ink leading-tight group-hover:text-terra transition-colors line-clamp-1">{book.baslik}</h3>
          <span className={`text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded-full border ${diffColor[book.zorluk_seviyesi] || ""}`}>{book.zorluk_seviyesi}</span>
        </div>
        <p className="text-xs text-muted-foreground">{book.yazar}{book.yayinevi ? ` · ${book.yayinevi}` : ""}</p>
        <div className="flex items-center gap-3 mt-0.5">
          {book.topluluk_puani > 0 && (
            <span className="flex items-center gap-1 text-xs text-ink-2"><Star size={11} className="fill-gold text-gold" /> {book.topluluk_puani}</span>
          )}
          <span className="text-[11px] text-muted-foreground">{book.okuyan_sayisi} okur</span>
        </div>
      </div>
      <ChevronRight className="text-muted-foreground group-hover:text-terra transition-colors shrink-0" size={16} />
    </Link>
  );
}
